import * as React from 'react';
import { IDs } from '../helpers/IDs';
import { WFormFieldMultiselect } from '../core/forms/fields/WFormFieldMultiselect';
import plzHwkMap from '../helpers/hwk.json';

interface EditBeraterzuordnungProps extends React.ClassAttributes<any> {
    data: any;
    plz: number | string;
    onChange: (beraterTids: Array<number>) => void;
}

export class EditBeraterzuordnung extends React.Component<EditBeraterzuordnungProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        let options = this.getOptions();
        const plz = this.props.plz;
        // const optPlz = options.filter((o: any) => o.fromRegion);
        let msg;
        if (!plz || (plz + '').length < 5) {
            msg = 'Bitte geben Sie eine PLZ ein.';
            options = [];
        } else if (options.length === 0) {
            msg = 'Zurzeit sind in Ihrer Region noch keine Berater:innen zugeordnet.';
        }

        return <div style={{ width: '100%', paddingRight: 10, marginBottom: 20 }}>
            <div style={{ marginBottom: 5 }}>Zuordnung Berater:innen/Expert:innen</div>
            {msg && <div style={{ padding: 5, backgroundColor: '#bccae3', fontStyle: 'italic' }}>
                {msg}
            </div>}
            <WFormFieldMultiselect
                hideSearch={true}
                options={options}
                onChange={(opts: Array<any>) => {
                    const beraterTids = opts.filter((o: any) => o.selected === true).map((o: any) => o.tid);
                    this.props.onChange(beraterTids);
                }}
            />
        </div>;
    }

    isPLZbereich(bereich: string, plz: number | string) {
        if (isNaN(+plz) || !bereich) {
            return false;
        }
        const plzs: Array<number> = [];
        // Bereich parsen
        const parts = bereich.trim().split(',');
        parts.forEach((p: string) => {
            if (!isNaN(+p)) {
                plzs.push(+p);
            } else {
                const split = p.split('-');
                if (split.length === 2 && !isNaN(+split[0].trim()) && !isNaN(+split[1].trim())) {
                    for (let i = +split[0].trim(); i <= +split[1].trim(); i++) {
                        plzs.push(i);
                    }
                }
            }
        });
        return plzs.indexOf(+plz) > -1;
    }

    getOptions() {
        const { data, plz } = this.props;
        const phMap: any = { ...plzHwkMap };
        const hwk = phMap[+plz];
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;

        let opts: Array<any> = [];
        if (Array.isArray(data[IDs.ENT_BERATER])) {
            // Berater für weitere Bereiche
            let beraterFiltered = data[IDs.ENT_BERATER].filter((b: any) => b.bereich_key_orig === bereich_key
                || data[IDs.ENT_BERATER_BEREICHE].find((bw: any) => bw.berater_orig === b.tid && bw.bereich_key_orig === bereich_key));
            beraterFiltered = beraterFiltered.filter((b: any) => (b.extern === 0 || b.extern === null) &&
                ((hwk && b.hwk === hwk) || (plz && (b.hwk || '').indexOf(plz) > -1) || this.isPLZbereich(b.plz_bereiche, plz) ||
                    (data.RES_MAIN_LOAD_BERATER || []).some((lb: any) => lb.tid === b.tid)));
            opts = beraterFiltered.map((br: any) => {
                const selected = (data.RES_MAIN_LOAD_BERATER || []).some((lb: any) => lb.tid === br.tid);
                return {
                    tid: br.tid,
                    name: br.name + (br.hwk ? ` (${br.hwk})` : '') + (br.telefon ? ` - Tel: ${br.telefon}` : ''),
                    selected,
                    fromRegion: (hwk && br.hwk === hwk) || (plz && (br.hwk || '').indexOf(plz) > -1) ? true : false,
                };
            });
        }
        // console.log(plz, opts);
        return opts;
    }
}
